<template>
  <div class="set-index">
    <SetIndex :menu="menu"></SetIndex>
  </div>
</template>

<script>
import SetIndex from "@/components/set-index/index.vue";
export default {
  name: "Page",
  components: { SetIndex },
  data() {
    const _this = this;
    return {
      menu: [
        {
          name: "脉动参数",
          icon: require("../../../assets/maidong.png"),
          className: "zhushe",
          arr: [
            { name: "班次设置", to: { name: "userAutoSet" } },
            { name: "参数设置", to: { name: "userSetParam" } },
          ],
        },
        {
          name: "系统设置",
          className: "xitong",
          icon: require("../../../assets/chilun@3x.png"),
          // arr: [{ name: "系统设置", to: { name: "AboutNew" } }],
          arr: [{ name: "系统设置", to: { name: "userSetSystemHome" } }],
        },
      ],
    };
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
